import {
  HiqLrpTypeCodeNames,
  RmaCommodityTypeNames,
  RmaLrpCommodityCodes,
  RmaLrpCommodityNames,
  RmaLrpTypeCodes,
} from '@harvestiq/constants';
import { z, zDecimalRequired, zIsoDate } from '@harvestiq/zod';
import { dbLrpRateDailySchema } from './db-lrp-rate-daily';

export const lrpQuoteSchema = dbLrpRateDailySchema
  .omit({
    coveragePrice: true,
  })
  .extend({
    commodityCode: z.nativeEnum(RmaLrpCommodityCodes),
    commodityName: z.nativeEnum(RmaLrpCommodityNames),
    commodityTypeName: z.nativeEnum(RmaCommodityTypeNames),
    typeCode: z.nativeEnum(RmaLrpTypeCodes),
    typeDisplay: z.nativeEnum(HiqLrpTypeCodeNames),
    optionsName: z.string(),
    priceAdjustmentFactor: zDecimalRequired(),
    barchartFuturesSymbol: z.string().nullable(),
    endDateMonth: z.string(),
    endDateMonthName: z.string(),
    // below are obtained from barchart futures data
    monthDiff: z.number(),
    cmeEquivalentDateMonth: z.string(),

    comparisonPricePerCwt: zDecimalRequired(),
    comparisonPricePerHead: zDecimalRequired(),
    comparisonPriceTotal: zDecimalRequired(),

    finalSettlementPerCwt: zDecimalRequired(),
    finalSettlementPerHead: zDecimalRequired(),
    finalSettlementTotal: zDecimalRequired(),

    last: zDecimalRequired(),
    previousClose: zDecimalRequired(),
    settlement: z.number().optional(),
    previousSettlement: z.number().optional(),
    savingsVsCmeTrade: zDecimalRequired(),
    savingsVsCmeTradeDollar: zDecimalRequired(),
    publicationDate: z.string(),
    commodityType: z.string(), // It differs from commodityTypeName as it has weight information
    // below are duplicates but we need to keep as the api is exposed - backwards compatibility
    commodity: z.string(),
    marketingDate: zIsoDate(),

    coverageLevel: zDecimalRequired(),
    marketingMonthNumber: z.string().optional(),

    coveragePricePerCwt: zDecimalRequired(),
    coveragePricePerHead: zDecimalRequired(),
    coveragePriceTotal: zDecimalRequired(),

    livestockRate: zDecimalRequired(),
    expectedEndingValueTotal: zDecimalRequired(),
    expectedEndingValuePerHead: zDecimalRequired(),
    expectedEndingValuePerCwt: zDecimalRequired(),

    liabilityAmountTotal: zDecimalRequired(),
    liabilityAmountPerHead: zDecimalRequired(),
    liabilityAmountPerCwt: zDecimalRequired(),

    totalPremium: zDecimalRequired(),
    totalPremiumPerHead: zDecimalRequired(),
    totalPremiumPerCwt: zDecimalRequired(),

    subsidyRate: zDecimalRequired(),
    subsidyTotal: zDecimalRequired(),
    subsidyPerHead: zDecimalRequired(),
    subsidyPerCwt: zDecimalRequired(),

    producerPremiumTotal: zDecimalRequired(),
    producerPremiumPerHead: zDecimalRequired(),
    producerPremiumPerCwt: zDecimalRequired(),
  });

export type LrpQuote = z.infer<typeof lrpQuoteSchema>;
